import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Home from './pages/home';
import { CartProvider } from './components/CartContext';
import { WishlistProvider } from './components/WishlistContext';
import CategoryPage from './pages/categoryPage';
import WishlistPage from './pages/wishlistPage';
import ProductDetail from './pages/productDetail';
import CartPage from './pages/CartPage';
import About from './pages/about';
import Contact from './pages/contact';
import PrivacyPolicy from './pages/privacyPolicy';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import NewsletterSubscribe from './pages/subscribe';
import NewsletterUnsubscribe from './pages/unsubscribe';
import SearchPage from './pages/searchPage';
import CheckoutPage from './pages/CheckoutPage';
import Blogs from './pages/blogs';

function App() {
  return (
    <Router>
      <CartProvider>
        <WishlistProvider>
          <Navbar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/wishlist' element={<WishlistPage />} />
            <Route path='/cart' element={<CartPage />} />
            <Route path='/checkout' element={<CheckoutPage />} />
            <Route path='/product/:category/:subcategory?/:id' element={<ProductDetail />} />
            <Route path='/category/:category/:subcategory?' element={<CategoryPage />} />
            <Route path='/search' element={<SearchPage />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/blogs' element={<Blogs />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/return-refund' element={<ReturnRefundPolicy />} />
            <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
            <Route path='/subscribe' element={<NewsletterSubscribe />} />
            <Route path='/unsubscribe' element={<NewsletterUnsubscribe />} />
          </Routes>
          <Footer/>
        </WishlistProvider>
      </CartProvider>
    </Router>
  );
}

export default App;
